<template>
  <component-data :title="trans.get('wizard.addressTitle')" :expandable="expandable">
    <form>
      <floating-input
        v-for="(item, index) in addressForm.personal"
        :key="index"
        :name="index"
        :placeholder="trans.get(`wizard.${index}`)"
        :initialValue="item.value"
        :initialErrors="item.errors"
        @handle-change="handleAddressChange"
        type="text"
        class="mt-2"
      ></floating-input>
      <floating-input
        name="postal"
        :placeholder="trans.get('wizard.postal')"
        :initialValue="addressForm.postal.value"
        :initialErrors="addressForm.postal.errors"
        @handle-change="handlePostalChange"
        type="text"
        class="mt-2"
      ></floating-input>
      <v-select
        :options="regions.map((r) => r.name)"
        :placeholder="trans.get('wizard.country')"
        @input="handleCountryChange"
        :value="addressForm.country.value"
      >
      </v-select>
      <floating-input
        name="observations"
        :placeholder="trans.get('wizard.observations')"
        :initialValue="addressForm.observations.value"
        :initialErrors="addressForm.observations.errors"
        @handle-change="handleObservationsChange"
        type="text"
        class="mt-2"
      ></floating-input>
    </form>
    <template v-slot:minimized-slot>
      <slot></slot>
    </template>
  </component-data>
</template>

<script>
import {
  GET_ADDRESS_DATA,
  SET_ADDRESS_DATA_MUTATION,
  GET_REGIONS,
  RETREIVE_SHIPPING_TYPE,
} from "../../../store/wizard/types";
import mixin from "../../../mixin";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  mixins: [mixin],
  props: {
    expandable: {
      Type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      addressForm: GET_ADDRESS_DATA,
      regions: GET_REGIONS,
    }),
  },
  methods: {
    ...mapMutations({
      setAddressData: SET_ADDRESS_DATA_MUTATION,
    }),
    ...mapActions({
      retreiveShippingType: RETREIVE_SHIPPING_TYPE,
    }),
    handleAddressChange(payload) {
      this.setAddressData({
        ...this.addressForm,
        personal: {
          ...this.addressForm["personal"],
          [payload.name]: {
            ...this.addressForm["personal"][payload.name],
            value: payload.value,
          },
        },
      });
    },
    handlePostalChange(payload) {
      this.setAddressData({
        ...this.addressForm,
        postal: {
          ...this.addressForm["postal"],
          value: payload.value,
        },
      });
      this.retreiveShippingType(this.addressForm);
    },
    handleObservationsChange(payload) {
      this.setAddressData({
        ...this.addressForm,
        observations: {
          ...this.addressForm["observations"],
          value: payload.value,
        },
      });
    },
    handleCountryChange(payload) {
      this.setAddressData({
        ...this.addressForm,
        country: {
          ...this.addressForm["country"],
          value: payload,
        },
      });
      this.retreiveShippingType(this.addressForm);
    },
  },
};
</script>

<style>
</style>
